import {Link} from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import {WebContext} from '../webcontext';

import { FaFacebook, FaMixcloud, FaTwitch } from "react-icons/fa6";

export default function Footer() {
  const service = useContext(WebContext);

  switch(service.web?.service.template) {
    case 2:
      return(
        <footer className="site-footer">
          <div className="footer-content">
            <div className="footer-brand">
              <p className="footer-tagline">The Best DJs. The Best Music. 24/7</p>
              <p className="footer-desc">Created by DJs, for DJs. House music community from around the world.</p>
            </div>
            <div className="footer-links">
              <a href="/schedule" data-nav="">Schedule</a>
              <a href="/djs" data-nav="">Our DJs</a>
              <a href="/events" data-nav="">Events</a>
              <a href="/shop" data-nav="">Shop</a>
              <a href="/listen" data-nav="">Listen &amp; Connect</a>
              <a href="/privacy" data-nav="">Privacy Policy</a>
              <a href="/terms" data-nav="">Terms &amp; Conditions</a>
            </div>
            <div className="footer-social">
              <a href="https://www.facebook.com/4themusic.club" target="_blank" title="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="https://www.instagram.com/4themusic_official/" target="_blank" title="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="https://www.twitch.tv/4themusicofficial" target="_blank" title="Twitch"><i className="fab fa-twitch"></i></a>
              <a href="https://www.mixcloud.com/4TheMusicClub/" target="_blank" title="Mixcloud"><i className="fab fa-mixcloud"></i></a>
              <a href="https://hearthis.at/4themusic" target="_blank" title="HearThis"><i className="fas fa-headphones"></i></a>
              <a href="https://www.youtube.com/@4TheMusicOfficial" target="_blank" title="YouTube"><i className="fab fa-youtube"></i></a>
            </div>
            <div className="footer-app">
              <p className="footer-tagline">Get the App</p>
              <a href="https://apps.apple.com/us/app/4-the-music-radio/id6456125970" target="_blank" className="play-badge">
                <i className="fab fa-apple"></i>
                <span>
                  <small>Download on the</small>
                  <strong>App Store</strong>
                </span>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.fourthemusic" target="_blank" className="play-badge">
                <i className="fab fa-google-play"></i>
                <span>
                  <small>GET IT ON</small>
                  <strong>Google Play</strong>
                </span>
              </a>
              <a href="https://channelstore.roku.com/details/e94b40970590a913536a5dff9bcc4fad:85b2f25690033349bb881f84c7d23f82/4-the-music" target="_blank" className="roku-badge">
                <span className="roku-badge-action">
                  <small>ADD TO</small>
                  <img src="/images/roku-logo-white.svg" alt="Roku" className="roku-badge-logo" />
                </span>
              </a>
            </div>
          </div>
          <div className="footer-bottom">
            © Copyright 2026 <Link to={'/'} className="pra-clr primaryhover cmn-hover">{service.web.service.title}</Link>
          </div>
        </footer>
      )
    case 1:
      return (
        <footer className="footer-version-one heading-bg zindex1 position-relative">
          <div className="container">
            <div className="footer-topversion-one pt-20 pb-20">
              <div className="row gy-lg-0 gy-10 mt-xxl-5 mb-xxl-5 justify-content-sm-between justify-content-center">
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <p className="white-clr fs20 body-font mb-xxl-7 mb-6 aos-init" data-aos="zoom-in" data-aos-duration="1600">
                      A rotating timetable featuring House, Techno, Bass, Trance, Drum & Bass, and more. Special events: live DJ takeovers and guest mixes.
                    </p>
                    <ul className="common-social d-flex align-items-center gap-2">
                      {Object.keys(service.web?.service).filter(elem => elem.indexOf('s_') === 0 && elem !== 's_website').map((e, i) => {
                        switch(e) {
                          case 's_facebook':
                            return
                              <li key={i} data-aos="zoom-in-right" data-aos-duration="1400" className="aos-init">
                                <a href={service.web.service[e]} target="_blank" className="d-center socialbg border-0 radius100">
                                  <FaFacebook />
                                </a>
                              </li>
                          case 's_mixcloud':
                            return (
                              <li key={i} data-aos="zoom-in-right" data-aos-duration="1400" className="aos-init">
                                <a href={service.web.service[e]} target="_blank" className="d-center socialbg border-0 radius100">
                                  <FaMixcloud />
                                </a>
                              </li>
                            );
                          case 's_twitch':
                          return (
                              <li key={i} data-aos="zoom-in-right" data-aos-duration="1400" className="aos-init">
                                <a href={service.web.service[e]} target="_blank" className="d-center socialbg border-0 radius100">
                                  <FaTwitch />
                                </a>
                              </li>
                            );
                          default:
                            return null;
                        }
                      })}
                      {/*<li data-aos="zoom-in-right" data-aos-duration="1400" className="aos-init">
                        <a href="#" className="d-center socialbg border-0 radius100">
                          <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.8" clip-path="url(#clip0_6308_28)">
                              <path d="M8.72266 9L9.16703 6.10437H6.38859V4.22531C6.38859 3.43313 6.77672 2.66094 8.02109 2.66094H9.28422V0.195625C9.28422 0.195625 8.13797 0 7.04203 0C4.75391 0 3.25828 1.38688 3.25828 3.8975V6.10437H0.714844V9H3.25828V16H6.38859V9H8.72266Z" fill="white"></path>
                            </g>
                            <defs>
                              <clipPath id="clip0_6308_28">
                                <rect width="10" height="16" fill="white"></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </a>
                      </li>
                      <li data-aos="zoom-in-right" data-aos-duration="1600" className="aos-init">
                        <a href="#" className="d-center socialbg border-0 radius100">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.3553 4.74149C14.3655 4.88362 14.3655 5.02577 14.3655 5.1679C14.3655 9.5029 11.066 14.4978 5.03553 14.4978C3.17766 14.4978 1.45178 13.9597 0 13.0258C0.263969 13.0562 0.51775 13.0664 0.791875 13.0664C2.32484 13.0664 3.73603 12.5486 4.86294 11.6654C3.42131 11.6349 2.21319 10.6907 1.79694 9.39124C2 9.42168 2.20303 9.44199 2.41625 9.44199C2.71066 9.44199 3.00509 9.40137 3.27919 9.33034C1.77666 9.02574 0.649719 7.70596 0.649719 6.11205V6.07146C1.08625 6.31512 1.59391 6.4674 2.13194 6.48768C1.24869 5.89884 0.670031 4.89377 0.670031 3.75671C0.670031 3.14759 0.832437 2.58921 1.11672 2.1019C2.73094 4.09174 5.15734 5.39121 7.87812 5.53337C7.82737 5.28971 7.79691 5.03593 7.79691 4.78212C7.79691 2.97499 9.25884 1.50293 11.0761 1.50293C12.0202 1.50293 12.873 1.89887 13.472 2.53846C14.2131 2.39634 14.9238 2.12221 15.5532 1.74659C15.3096 2.50802 14.7918 3.14762 14.1116 3.55368C14.7715 3.48265 15.4111 3.29987 15.9999 3.04609C15.5533 3.6958 14.9949 4.27446 14.3553 4.74149V4.74149Z" fill="white"></path>
                          </svg>
                        </a>
                      </li>
                      <li data-aos="zoom-in-right" data-aos-duration="1800" className="aos-init">
                        <a href="#" className="d-center socialbg border-0 radius100">
                          <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.8">
                              <path d="M3.13375 13.9997H0.23125V4.65281H3.13375V13.9997ZM1.68094 3.37781C0.752813 3.37781 0 2.60906 0 1.68094C6.64312e-09 1.23513 0.177098 0.807572 0.492335 0.492335C0.807572 0.177098 1.23513 0 1.68094 0C2.12675 0 2.5543 0.177098 2.86954 0.492335C3.18478 0.807572 3.36188 1.23513 3.36188 1.68094C3.36188 2.60906 2.60875 3.37781 1.68094 3.37781ZM13.9969 13.9997H11.1006V9.44969C11.1006 8.36531 11.0787 6.97469 9.59156 6.97469C8.0825 6.97469 7.85125 8.15281 7.85125 9.37156V13.9997H4.95188V4.65281H7.73562V5.92781H7.77625C8.16375 5.19344 9.11031 4.41844 10.5225 4.41844C13.46 4.41844 14 6.35281 14 8.86531V13.9997H13.9969Z" fill="white"></path>
                            </g>
                          </svg>
                        </a>
                      </li>
                      <li data-aos="zoom-in-right" data-aos-duration="1900" className="aos-init">
                        <a href="#" className="d-center socialbg border-0 radius100">
                          <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.1769 1.87759C16.9806 1.13853 16.4023 0.556469 15.668 0.358938C14.337 0 9.00014 0 9.00014 0C9.00014 0 3.66327 0 2.3323 0.358938C1.59802 0.5565 1.0197 1.13853 0.823422 1.87759C0.466797 3.21719 0.466797 6.01213 0.466797 6.01213C0.466797 6.01213 0.466797 8.80706 0.823422 10.1467C1.0197 10.8857 1.59802 11.4435 2.3323 11.6411C3.66327 12 9.00014 12 9.00014 12C9.00014 12 14.337 12 15.668 11.6411C16.4023 11.4435 16.9806 10.8857 17.1769 10.1467C17.5335 8.80706 17.5335 6.01213 17.5335 6.01213C17.5335 6.01213 17.5335 3.21719 17.1769 1.87759V1.87759ZM7.25467 8.54972V3.47453L11.7153 6.01219L7.25467 8.54972V8.54972Z" fill="white"></path>
                          </svg>
                        </a>
                      </li>*/}
                    </ul>
                  </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <div className="footer-title d-flex align-items-center fs20 fw-700 body-font gap-2 mb-xxl-8 mb-xl-6 mb-5 aos-init" data-aos="zoom-in-down" data-aos-duration="1900">
                      Explore
                      <img src="/images/line.webp" alt="img" />
                    </div>
                    <ul className="link-footer d-grid gap-xxl-3 gap-3 aos-init" data-aos="zoom-in" data-aos-duration="1400">
                      <li>
                        <Link to={'/about'} className="d-flex align-items-center gap-2 flink-items pra-clr">
                          About
                        </Link>
                      </li>
                      <li>
                        <Link to={'/schedule'} className="d-flex align-items-center gap-2 flink-items pra-clr">
                          Schedule
                        </Link>
                      </li>
                      <li>
                        <Link to={'/previous'} className="d-flex align-items-center gap-2 flink-items pra-clr">
                          Previous
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <div className="footer-title d-flex align-items-center fs20 fw-700 body-font gap-2 mb-xxl-8 mb-xl-6 mb-5 aos-init" data-aos="zoom-in-down" data-aos-duration="1900">
                      Our DJ's
                      <img src="/images/line.webp" alt="img" />
                    </div>
                    <ul className="link-footer d-grid gap-xxl-3 gap-3 aos-init" data-aos="zoom-in" data-aos-duration="1400">
                      <li>
                        <Link to={'/ourdjs'} className="d-flex align-items-center gap-2 flink-items pra-clr">
                          OurDJs
                        </Link>
                      </li>
                      <li>
                        <Link to={'/joinus'} className="d-flex align-items-center gap-2 flink-items pra-clr">
                          Join Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <div className="footer-title d-flex align-items-center fs20 fw-700 body-font gap-2 mb-xxl-8 mb-xl-6 mb-5 aos-init" data-aos="zoom-in-down" data-aos-duration="1900">
                      Contact
                      <img src="/images/line.webp" alt="img" />
                    </div>
                    <div className="widget-call d-grid gap-xxl-4 gap-3">
                      <div className="d-flex align-items-center gap-xxl-4 gap-3">
                        <i className="fas fa-clock pra-clr"></i>
                        <span className="pra-clr">
                          Mon - Sun: 8AM - 8PM
                        </span>
                      </div>
                      <div className="d-flex align-items-center gap-xxl-4 gap-3">
                        <i className="fas fa-envelope pra-clr"></i>
                        <a href="mailto:contact@dnaradio.uk" className="cmn-hover pra-clr">
                          contact@dnaradio.uk
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom-version-one heading-bg overflow-hidden cmn-bordert text-center px-xxl-7 px-6 py-xxl-6 py-xl-6 py-3">
            <p className="pra-clr">
              © Copyright 2026 <Link to={'/'} className="pra-clr primaryhover cmn-hover">{service.web.service.title}</Link>
            </p>
          </div>

          <img src="/images/footer-element.webp" alt="img" className="footer-sound-element" />
        </footer>
      )
    default:
      return (<></>)
  }
}
